//utils/api.js - Refactorización completa

// Configuración de la URL base
const getApiBaseUrl = () => {
  //const baseUrl = process.env.REACT_APP_API_BASE_URL || "http://red.arauca";
  const baseUrl = process.env.REACT_APP_API_BASE_URL || "https://redarauca.com";
  // Limpiar barras finales
  return baseUrl.replace(/\/+$/, "");
};

export const API_BASE_URL = getApiBaseUrl();

// Función auxiliar para construir URLs completas
const buildUrl = (endpoint) => {
  const cleanEndpoint = endpoint.startsWith("/") ? endpoint : `/${endpoint}`;
  const fullUrl = `${API_BASE_URL}${cleanEndpoint}`;
  return fullUrl;
};

export const apiEndpoints = {
  // Settings del sitio
  settings: {
    public: () => buildUrl("/api/site_settings.php?action=public"),
    contactInfo: () => buildUrl("/api/site_settings.php?action=contact_info"),
    socialMedia: () => buildUrl("/api/site_settings.php?action=social_media"),
    all: () => buildUrl("/api/site_settings.php?action=all"),
  },

  // Menús
  menus: {
    list: () => buildUrl("/api/menus.php?action=list"),
    single: (id) => buildUrl(`/api/menus.php?action=single&menu=${id}`),
    bySlug: (slug) => buildUrl(`/api/menus.php?action=single&menu=${slug}`),
  },

  // Posts - REFACTORIZADO con construcción segura de URLs
  posts: {
    list: (page = 1, limit = 10, category = null) => {
      const params = new URLSearchParams({
        action: "list",
        page: page.toString(),
        limit: limit.toString(),
      });

      if (category) {
        params.append("category", category.toString());
      }

      return buildUrl(`/api/posts.php?${params.toString()}`);
    },

    single: (slug) => {
      const params = new URLSearchParams({
        action: "single",
        slug: slug,
      });
      return buildUrl(`/api/posts.php?${params.toString()}`);
    },

    featured: (limit = 5) => {
      const params = new URLSearchParams({
        action: "featured",
        limit: limit.toString(),
      });
      return buildUrl(`/api/posts.php?${params.toString()}`);
    },

    pinned: (limit = 5) => {
      const params = new URLSearchParams({
        action: "pinned",
        limit: limit.toString(),
      });
      return buildUrl(`/api/posts.php?${params.toString()}`);
    },

    latest: (limit = 5) => {
      const params = new URLSearchParams({
        action: "latest",
        limit: limit.toString(),
      });
      return buildUrl(`/api/posts.php?${params.toString()}`);
    },

    search: (query) => {
      const params = new URLSearchParams({
        action: "search",
        q: query,
      });
      return buildUrl(`/api/posts.php?${params.toString()}`);
    },
  },

  // Categorías
  categories: {
    list: () => buildUrl("/api/categories.php?action=list"),
    single: (id) => buildUrl(`/api/categories.php?action=single&id=${id}`),
    bySlug: (slug) =>
      buildUrl(`/api/categories.php?action=single&slug=${slug}`),
    posts: (categoryId, page = 1, limit = 10) => {
      const params = new URLSearchParams({
        action: "posts",
        id: categoryId.toString(),
        page: page.toString(),
        limit: limit.toString(),
      });
      return buildUrl(`/api/categories.php?${params.toString()}`);
    },
  },

  // Carruseles
  carousels: {
    active: (limit = null) => {
      const params = new URLSearchParams({ action: "active" });
      if (limit) {
        params.append("limit", limit.toString());
      }
      return buildUrl(`/api/carousels.php?${params.toString()}`);
    },
  },

  // Media Outlets
  mediaOutlets: {
    list: (
      page = 1,
      limit = 20,
      search = null,
      mediaType = null,
      city = null
    ) => {
      const params = new URLSearchParams({
        action: "list",
        page: page.toString(),
        limit: limit.toString(),
      });

      if (search) params.append("search", search);
      if (mediaType) params.append("media_type", mediaType);
      if (city) params.append("city", city);

      return buildUrl(`/api/media_outlets.php?${params.toString()}`);
    },

    single: (id) => buildUrl(`/api/media_outlets.php?action=single&id=${id}`),
    latest: (limit = 5) =>
      buildUrl(`/api/media_outlets.php?action=latest&limit=${limit}`),
    stats: () => buildUrl("/api/media_outlets.php?action=stats"),
    filters: () => buildUrl("/api/media_outlets.php?action=filters"),
  },

  // Managers
  managers: {
    list: () => buildUrl("/api/managers.php"),
  },

  // Stats
  stats: {
    general: () => buildUrl("/api/stats.php?action=general"),
    posts: () => buildUrl("/api/stats.php?action=posts"),
    mediaOutlets: () => buildUrl("/api/stats.php?action=media_outlets"),
    socialMedia: () => buildUrl("/api/stats.php?action=social_media"),
    growth: () => buildUrl("/api/stats.php?action=growth"),
    topContent: () => buildUrl("/api/stats.php?action=top_content"),
  },
};

// Función helper mejorada para hacer llamadas a la API
export const fetchAPI = async (endpoint) => {
  try {
    const response = await fetch(endpoint, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      // Agregar modo CORS si es necesario
      mode: "cors",
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `HTTP error! status: ${response.status} - ${response.statusText}`
      );
    }

    const contentType = response.headers.get("content-type");

    if (contentType && contentType.includes("application/json")) {
      const data = await response.json();
      return data;
    } else {
      const text = await response.text();

      // Intentar parsear como JSON si parece serlo
      if (text.trim().startsWith("{") || text.trim().startsWith("[")) {
        try {
          return JSON.parse(text);
        } catch (parseError) {
          throw new Error("Respuesta del servidor no es JSON válido");
        }
      }

      throw new Error("La respuesta del servidor no es JSON");
    }
  } catch (error) {
    // Proporcionar mensajes de error más específicos
    if (
      error.name === "TypeError" &&
      error.message.includes("Failed to fetch")
    ) {
      throw new Error(
        "Error de red: No se puede conectar con el servidor. Verifica tu conexión a internet."
      );
    }

    if (error.message.includes("CORS")) {
      throw new Error(
        "Error de CORS: El servidor no permite esta petición desde este origen."
      );
    }

    throw error;
  }
};

// Función auxiliar para construir URLs de imágenes
export const getImageUrl = (imagePath) => {
  if (!imagePath) return null;

  if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
    return imagePath;
  }

  return `${API_BASE_URL}/uploads/${imagePath}`;
};

// Funciones de utilidad para diferentes métodos HTTP
export const get = (endpoint) => fetchAPI(endpoint);

export const post = async (endpoint, data) => {
  try {
    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      mode: "cors",
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const put = async (endpoint, data) => {
  try {
    const response = await fetch(endpoint, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      mode: "cors",
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const del = async (endpoint) => {
  try {
    const response = await fetch(endpoint, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
      },
      mode: "cors",
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

// Funciones específicas para casos comunes
export const getPosts = (page = 1, limit = 10, category = null) =>
  fetchAPI(apiEndpoints.posts.list(page, limit, category));

export const getPost = (slug) => fetchAPI(apiEndpoints.posts.single(slug));

export const getFeaturedPosts = (limit = 5) =>
  fetchAPI(apiEndpoints.posts.featured(limit));

export const getLatestPosts = (limit = 5) =>
  fetchAPI(apiEndpoints.posts.latest(limit));

export const getPinnedPosts = (limit = 5) =>
  fetchAPI(apiEndpoints.posts.pinned(limit));

export const searchPosts = (query) =>
  fetchAPI(apiEndpoints.posts.search(query));

export const getCategories = () => fetchAPI(apiEndpoints.categories.list());

export const getCategory = (id) => fetchAPI(apiEndpoints.categories.single(id));

export const getCategoryPosts = (categoryId, page = 1, limit = 10) =>
  fetchAPI(apiEndpoints.categories.posts(categoryId, page, limit));

export const getSettings = () => fetchAPI(apiEndpoints.settings.all());

export const getMenus = () => fetchAPI(apiEndpoints.menus.list());

export const getCarousels = (limit = null) =>
  fetchAPI(apiEndpoints.carousels.active(limit));

export const getMediaOutlets = (
  page = 1,
  limit = 20,
  search = null,
  mediaType = null,
  city = null
) =>
  fetchAPI(
    apiEndpoints.mediaOutlets.list(page, limit, search, mediaType, city)
  );

// NUEVA FUNCIÓN PARA MANAGERS
export const getManagers = () => fetchAPI(apiEndpoints.managers.list());

// Exportar configuración por defecto
export default {
  API_BASE_URL,
  apiEndpoints,
  fetchAPI,
  getImageUrl,
  get,
  post,
  put,
  del,
  // Funciones específicas
  getPosts,
  getPost,
  getFeaturedPosts,
  getLatestPosts,
  getPinnedPosts,
  searchPosts,
  getCategories,
  getCategory,
  getCategoryPosts,
  getSettings,
  getMenus,
  getCarousels,
  getMediaOutlets,
  getManagers, // NUEVA FUNCIÓN EXPORTADA
};
